<div class="card-inner-main-div greyed-text">
    <div class="card-main-title border-bottom">
        <h4 class="card-title">{{ 'Control History' | translate }}<span class="small-light-text d-block">{{ 'Exposure Reduction Plan Items' | translate }}</span></h4>
    </div>
    <div class="tableColStyle">
        <div class="table-responsive">
            <table class="table">
                <thead>
                    <tr>
                        <th class="pl-0" scope="col">
                            <a>{{ 'Location' | translate }}</a>
                        </th>
                        <th scope="col">
                            <a>{{ 'Description' | translate }}</a>
                        </th>
                        <th scope="col">
                            <a>{{ 'Implemented' | translate }}</a>
                        </th>
                        <th scope="col">
                            <a>{{ 'Effectiveness' | translate }}</a>
                        </th>
                        <th class="blank-td" scope="col">
                            <a></a>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td class="pl-0"><span class="font-700">Elkview</span></td>
                        <td><span class=""><a>Intervention 1: Air
                                    Filter Upgrade</a></span></td>
                        <td class="">04/23/2022</td>
                        <td>90%</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>